import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Pagination, Spin } from 'antd'
import InfoFilter from '../../../components/filter/infoFilter'
import EmptyInquiry from './empty'
import ImportInquiry from './import'

export default function Inquiry() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [inquiryData, setInquiryData] = useState({})
  const [currentPage, setCurrentPage] = useState(1)
  const [isLoading, setIsLoading] = useState(true)
  const [isImportInquiryVisible, setIsImportInquiryVisible] = useState(false)
  const [isEmptyInquiryVisible, setIsEmptyInquiryVisible] = useState(false)

  const initialConditions = {
    keywords: '',
    sort_filter: 0,
  }
  const [filterValue, setFilterValue] = useState(initialConditions)

  const getInquiryList = () => {
    axios.post('/p/info/inquiry/get', { 
      merchant_oid: merchantOid,
      keywords: filterValue.keywords,
      sort_filter: filterValue.sort_filter,
      page: currentPage, 
      per_page: 20
    })
      .then(function (response) {
        setIsLoading(false)
        if (response.errcode === 0) {
          setInquiryData({
            'total_page': response.data.total_page,
            'current_page': response.data.current_page,
            'total': response.data.total,
            'headers': response.data.thead,
            'inquiries': response.data.tbody
          })
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getInquiryList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid, filterValue, currentPage])

  return (
    <div className="public-page">
      <Spin spinning={isLoading}>
        <div className="public-container">
          <div className="public-header">
            <div className="public-title">录取查询</div>
            <InfoFilter 
              filterValue={filterValue} 
              setFilterValue={setFilterValue} 
              isEmptyVisible={() => { setIsEmptyInquiryVisible(true) }}
              isImportVisible={() => { setIsImportInquiryVisible(true) }} 
            />
          </div>
          
          <div className='public-main-style2'>
            <table className='public-main-style2-item'>
              <thead>
                <tr className='public-main-style2-thead'>
                  {inquiryData.headers && inquiryData.headers.map((header, index) => (
                    <th key={header} style={index === 0 ? {textAlign: 'left', paddingLeft: '20px', paddingRight: '50px'} : {paddingRight: '50px'}}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {inquiryData.inquiries && (inquiryData.inquiries.length > 0 ? (inquiryData.inquiries.map((item) => (
                  <tr className='public-main-style2-tbody' key={item.oid} onClick={() => { }}>
                    <td style={{textAlign: 'left', paddingLeft: '20px', paddingRight: '50px'}}>{item.category}</td>
                    <td style={{paddingRight: '50px'}}>{item.year}</td>
                    <td style={{paddingRight: '50px'}}>{item.name}</td>
                    <td style={{paddingRight: '50px'}}>{item.number}</td>
                    <td style={{paddingRight: '50px'}}>{item.student_id}</td>
                    {inquiryData.headers.map((header, index) => (
                      index >= 5 ? (
                        <td key={index} style={{ paddingRight: '50px' }}>
                          {item.others.hasOwnProperty(header) && item.others[header] != null ? item.others[header] : '-'}
                        </td>
                      ) : null
                    ))}
                  </tr>
                ))) : (
                  <tr className='public-main-style2-tbodyEmpty'>
                    <td colSpan={inquiryData.headers.length}><span>暂无数据</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className='pagination'>
            <Pagination 
              current={currentPage}
              total={inquiryData.total}
              pageSize={20}
              onChange={(page) => setCurrentPage(page)}
              showTotal={(total) => `共${total}条`}
              showSizeChanger={false}
              hideOnSinglePage={true}
              showQuickJumper={true}
            />
          </div>
        </div>
      </Spin>

      {isEmptyInquiryVisible && <EmptyInquiry
        getInquiryList={getInquiryList}
        isOpen={isEmptyInquiryVisible}
        isCancel={() => { setIsEmptyInquiryVisible(false) }}
      />}

      {isImportInquiryVisible && <ImportInquiry
        getInquiryList={getInquiryList}
        isOpen={isImportInquiryVisible}
        isCancel={() => { setIsImportInquiryVisible(false) }}
      />}
    </div>
  )
}
